<template>
    <div class=text-popup :class="{ 'is-active' : isActive }">

        <div class=popup-content>
            <div class=text v-html="this.text"></div>
        </div>

        <div class=close @click="$emit('close-popup')"></div>

    </div>
</template>
<script>
export default {
    name : 'TextPopup',
    props : {
        text     : String,
        isActive : Boolean,
        wp       : Boolean,
    },
}
</script>